import { AxiosResponse } from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { BASE_METHODS, CustomErrorType } from "../../constants/action-types";
import { ModifyPrivacyPolicyDTO } from "../../constants/dto/privacy-policy";
import {
  setPrivacyPolicyActionStart,
  setPrivacyPolicyErrorMessage,
  updatePrivacyPolicyInPrivacyPolicies,
} from "../../constants/reducers/privacy-policy.reducer";
import { TextEnum } from "../../constants/text";
import { timeoutError } from "../../constants/reducers/base.reducer";
import { store } from "../../store";
import { createCall } from "../base";

let requestBody: ModifyPrivacyPolicyDTO;

export const modifyPrivacyPolicy = async () => {
  store.dispatch(setPrivacyPolicyActionStart(true));
  const { text, privacyPolicy } = store.getState().privacyPolicy;

  const request = await createCall(
    "cms/privacy-policies/modify",
    BASE_METHODS.PUT,
    "application/json",
    "1.0.0",
    {
      id: privacyPolicy.id.toString(),
      text,
    },
    undefined,
  );

  try {
    const response = request as AxiosResponse;
    requestBody = plainToClass(ModifyPrivacyPolicyDTO, response.data);
    const errors = await validate(requestBody);
    if (errors.length > 0) {
      store.dispatch(
        setPrivacyPolicyErrorMessage(
          TextEnum.MODIFY_PRIVACY_POLICY_INVALID_RESPONSE,
        ),
      );
      return null;
    }
    store.dispatch(
      updatePrivacyPolicyInPrivacyPolicies({
        privacyPolicy: response.data.privacyPolicy,
      }),
    );
    return response;
  } catch (error) {
    const responseError = request as any;
    const errorResponseData: CustomErrorType = responseError.response?.data;
    if (errorResponseData) {
      let errorMessage = "";
      switch (errorResponseData.code) {
        case 2001:
          errorMessage = TextEnum.PRIVACY_POLICY_NOT_FOUND;
          break;
        default:
          break;
      }
      store.dispatch(setPrivacyPolicyErrorMessage(errorMessage));
      return null;
    }
    store.dispatch(setPrivacyPolicyActionStart(false));
    store.dispatch(timeoutError());
    return null;
  }
};
